import Dropdown from 'components/ReusableComponents/ManageHotel/Dropdown'
import TextInput from 'components/ReusableComponents/ManageHotel/TextInput'
import Toggle from 'components/ReusableComponents/Toggle'
import { PACKAGE_OPTIONS } from 'features/NewHotelDialog/constants'
import { handleDiscountChange } from 'features/NewHotelDialog/helpers'

import styles from '../../NewHotel.module.scss'

const PackageSelection = ({ formData, setFormData, handleFormChange }) => {
  const { selectedPackage, monthlyRate, discount, paymentPeriod, isAutoPayEnabled } =
    formData

  return (
    <div className={styles.packageSelectionContainer}>
      <div className={styles.packageSelection}>
        <h4 className={styles.sectionTitle}>Package selection</h4>
        {Object.entries(PACKAGE_OPTIONS).map(([value, option]) => (
          <div
            key={option.id}
            className={styles.packageOption}
            onClick={() => setFormData({ selectedPackage: value })}
          >
            <input
              type="radio"
              id={option.id}
              name="selectedPackage"
              value={value}
              checked={selectedPackage === value}
              onChange={e => setFormData({ selectedPackage: e.target.value })}
            />
            <span htmlFor={option.id}>{option.label}</span>
          </div>
        ))}
      </div>
      <div className={styles.formRow}>
        <TextInput
          type="text"
          label="Monthly package fee"
          name="monthlyRate"
          value={monthlyRate}
          onChange={handleFormChange}
        />
        <TextInput
          type="text"
          label="Discount applied"
          name="discount"
          value={discount}
          onChange={e => handleDiscountChange(e, monthlyRate, setFormData)}
        />
        <Dropdown
          label="Payment period"
          defaultVal="Semi-Annual"
          options={{
            quarterly: 'Quarterly',
            semiAnnual: 'Semi-Annual',
            annual: 'Annual'
          }}
          name="paymentPeriod"
          onChange={handleFormChange}
          value={paymentPeriod}
        />
      </div>
      <div className={styles.autoPayContainer}>
        <div className={styles.autoPayToggle}>
          <Toggle
            className={styles.toggle}
            checked={isAutoPayEnabled}
            label="Use automatic payments"
            handleChange={() => setFormData({ isAutoPayEnabled: !isAutoPayEnabled })}
          />
          {isAutoPayEnabled && (
            <div className={styles.autoPayText}>
              Using this prevents paying by physical check
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default PackageSelection
